<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="is_list_available">
      <ScreenerList :list="upcomingList.data" :is_upcoming="true"></ScreenerList>
    </v-flex>
    <v-flex xs12 v-if="upcomingList.data && upcomingList.data.length && total > 1">
      <div class="text-xs-center mb-4">
        <v-pagination
          v-model="page"
          :length="total"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import ScreenerList from '@/components/screener/List';
export default {
  name: 'ScreenerUpcoming',
  metaInfo() {
    return {
      title: 'Screeners',
    };
  },
  components: {
    ScreenerList,
  },
  computed: {
    ...mapState({
      upcomingList: (state) => state.screening.upcomingList,
    }),
    total: function() {
      return this.upcomingList.last_page;
    },
  },
  data: () => ({
    is_list_available: false,
    page: 1,
    perPage:20,
  }),
  watch: {
    upcomingList() {
      this.is_list_available = true;
    },
    page: {
      handler: 'getApiData',
      deep: true,
    },
  },
  created() {
    this.getApiData();
  },
  methods: {
    async getApiData() {
      try {
        this.$store.dispatch('screening/upcomingList',{
          page: this.page,
          perPage: this.perPage,
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
